import { render, staticRenderFns } from "./ListUsersTable.vue?vue&type=template&id=3945f8a0"
import script from "./ListUsersTable.vue?vue&type=script&lang=ts"
export * from "./ListUsersTable.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports